export const ATTRIBUTION_LS_KEY = 'el_attribution'
export const ATTRIBUTION_SYNC_LS_KEY = 'el_attribution_synced'
export const ATTRIBUTION_MAX_AGE = 60 * 60 * 24 * 90

export const ATTRIBUTION_FIELD_KEYS = [
  'gclid',
  'gbraid',
  'wbraid',
  'fbclid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'referrer',
  'landing_page',
  'timestamp',
  'sid',
  'fbc',
]

const COOKIE_NAME = {
  referrer: 'first_referrer',
  sid: 'wa_sid',
  fbc: '_fbc',
}

function cookieName(key) {
  return COOKIE_NAME[key] || key
}

export function captureAttribution() {
  if (typeof window === 'undefined') return

  var MAX_AGE = 60 * 60 * 24 * 90
  var LS_KEY = 'el_attribution'
  var stored = {}

  function getCookie(n) {
    var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)')
    return m ? decodeURIComponent(m[2]) : ''
  }

  function setCookie(n, v) {
    document.cookie =
      n + '=' + encodeURIComponent(v) + ';path=/;max-age=' + MAX_AGE + ';SameSite=Lax'
  }

  function cookieNameFor(key) {
    if (key === 'referrer') return 'first_referrer'
    if (key === 'sid') return 'wa_sid'
    if (key === 'fbc') return '_fbc'
    return key
  }

  try {
    stored = JSON.parse(localStorage.getItem(LS_KEY) || '{}') || {}
  } catch (e) {
    stored = {}
  }

  function getStored(key) {
    if (stored[key]) return stored[key]
    var fromCookie = getCookie(cookieNameFor(key))
    if (fromCookie) {
      stored[key] = fromCookie
      return fromCookie
    }
    return ''
  }

  function persist(key, value) {
    if (!value || getStored(key)) return
    stored[key] = value
    setCookie(cookieNameFor(key), value)
  }

  function makeSid() {
    var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    var sid = ''
    var i
    for (i = 0; i < 8; i++) {
      sid += chars.charAt(Math.floor(Math.random() * chars.length))
    }
    return sid
  }

  var params = new URLSearchParams(location.search)
  var known = ['gclid', 'gbraid', 'wbraid', 'fbclid']
  var i
  var key
  var value

  for (i = 0; i < known.length; i++) {
    value = params.get(known[i])
    if (value) persist(known[i], value)
  }

  params.forEach(function (v, k) {
    if (k.indexOf('utm_') === 0 && v) persist(k, v)
  })

  persist('referrer', document.referrer || 'direct')
  persist('landing_page', location.href)
  persist('timestamp', new Date().toISOString())
  persist('sid', makeSid())

  var fbclidUrl = params.get('fbclid')
  if (fbclidUrl && !getStored('fbc')) {
    persist('fbc', 'fb.1.' + Date.now() + '.' + fbclidUrl)
  }

  try {
    localStorage.setItem(LS_KEY, JSON.stringify(stored))
  } catch (e) {}

  function patchWaMeRef() {
    var sid = getStored('sid')
    if (!sid || typeof document === 'undefined') return
    var links = document.querySelectorAll('a[href*="wa.me"]')
    var i
    var href
    for (i = 0; i < links.length; i++) {
      href = links[i].getAttribute('href') || ''
      if (!href || href.indexOf('ref=') !== -1) continue
      links[i].setAttribute(
        'href',
        href + (href.indexOf('?') === -1 ? '?' : '&') + 'ref=' + encodeURIComponent(sid)
      )
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchWaMeRef)
  } else {
    patchWaMeRef()
  }
}

export function getAttributionInlineScript() {
  return '(' + captureAttribution.toString() + ')();'
}

function readStored() {
  if (typeof window === 'undefined') return {}

  var stored = {}
  try {
    stored = JSON.parse(localStorage.getItem(ATTRIBUTION_LS_KEY) || '{}') || {}
  } catch (e) {
    stored = {}
  }

  ATTRIBUTION_FIELD_KEYS.forEach(function (key) {
    if (stored[key]) return
    var match = document.cookie.match(
      '(?:^|; )' + cookieName(key).replace(/([$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
    )
    if (match) stored[key] = decodeURIComponent(match[1])
  })

  Object.keys(stored).forEach(function (key) {
    if (key.indexOf('utm_') === 0 && stored[key] && ATTRIBUTION_FIELD_KEYS.indexOf(key) === -1) {
      ATTRIBUTION_FIELD_KEYS.push(key)
    }
  })

  return stored
}

export function getAttribution() {
  return readStored()
}

export function getSessionCode() {
  return readStored().sid || ''
}

export function getAttributionFields() {
  var stored = readStored()
  var fields = {}

  Object.keys(stored).forEach(function (key) {
    if (stored[key] == null || stored[key] === '') return
    if (
      ATTRIBUTION_FIELD_KEYS.indexOf(key) !== -1 ||
      key.indexOf('utm_') === 0
    ) {
      fields[key] = String(stored[key])
    }
  })

  return fields
}

let sendAttribution = null

export function pushAttribution() {
  if (typeof window === 'undefined' || typeof sendAttribution !== 'function') return

  captureAttribution()
  var fields = getAttributionFields()
  if (!fields.sid) return

  var payload = JSON.stringify(fields)
  var last = ''
  try {
    last = localStorage.getItem(ATTRIBUTION_SYNC_LS_KEY) || ''
  } catch (e) {}
  if (last === payload) return

  Promise.resolve(sendAttribution(fields))
    .then(function () {
      try {
        localStorage.setItem(ATTRIBUTION_SYNC_LS_KEY, payload)
      } catch (e) {}
    })
    .catch(function () {})
}

function parseWhatsAppUrl(href) {
  var url
  try {
    url = new URL(href, typeof location !== 'undefined' ? location.origin : undefined)
  } catch (e) {
    return null
  }

  var host = url.hostname || ''
  var phone = url.searchParams.get('phone') || ''
  if (!phone && host.indexOf('wa.me') !== -1) {
    phone = url.pathname.replace(/^\//, '').split('/')[0] || ''
  }
  if (!phone) return null

  return {
    phone: phone,
    text: url.searchParams.get('text') || '',
    sid: url.searchParams.get('ref') || '',
  }
}

export function buildWhatsAppUrl(href, pageUrl) {
  if (!href || href.indexOf('wa.me') === -1) return href

  captureAttribution()
  var sid = getSessionCode()
  var parsed = parseWhatsAppUrl(href)
  if (!parsed) return href

  var text = parsed.text.replace(/\s*\((?:gclid|fbclid|wbraid|gbraid):[^)]*\)/g, '').trim()

  if (sid && text) {
    text = text
      .replace(new RegExp('(?:^|\\s)' + sid.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*$'), '')
      .trim()
  }

  if (!text && pageUrl) {
    text = 'Hello! Writing from ' + pageUrl
  }

  var result = 'https://wa.me/' + parsed.phone
  var parts = []
  if (text) parts.push('text=' + encodeURIComponent(text))
  if (sid) parts.push('ref=' + encodeURIComponent(sid))
  if (parts.length) result += '?' + parts.join('&')
  return result
}

function buildWhatsAppSendUrl(href, pageUrl) {
  var waHref = buildWhatsAppUrl(href, pageUrl)
  var parsed = parseWhatsAppUrl(waHref)
  if (!parsed) return waHref

  var sid = parsed.sid || getSessionCode()
  var send = 'https://api.whatsapp.com/send/?phone=' + encodeURIComponent(parsed.phone)
  if (parsed.text) send += '&text=' + encodeURIComponent(parsed.text)
  send += '&type=phone_number&app_absent=0'
  if (sid) send += '&ref=' + encodeURIComponent(sid)
  return send
}

let clickBound = false

function applyWhatsAppHref(link) {
  if (!link || !link.getAttribute) return
  var current = link.getAttribute('href') || link.href
  var next = buildWhatsAppUrl(current, typeof location !== 'undefined' ? location.href : '')
  if (next && next !== current) link.setAttribute('href', next)
}

function rewriteWhatsAppLinks() {
  if (typeof document === 'undefined') return
  var links = document.querySelectorAll('a[href*="wa.me"]')
  var i
  for (i = 0; i < links.length; i++) applyWhatsAppHref(links[i])
}

function onWhatsAppClick(event) {
  var link =
    event.target &&
    event.target.closest &&
    event.target.closest('a[href*="wa.me"], a[href*="api.whatsapp.com/send"]')
  if (!link) return

  applyWhatsAppHref(link)
  pushAttribution()

  if (event.defaultPrevented || event.button !== 0) return
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

  var sendUrl = buildWhatsAppSendUrl(
    link.getAttribute('href') || link.href,
    typeof location !== 'undefined' ? location.href : ''
  )
  if (!sendUrl) return

  event.preventDefault()
  window.open(sendUrl, link.target || '_blank', 'noopener,noreferrer')
}

export function initAttribution(send) {
  if (typeof window === 'undefined') return
  if (typeof send === 'function') sendAttribution = send
  captureAttribution()
  rewriteWhatsAppLinks()
  pushAttribution()
  setTimeout(rewriteWhatsAppLinks, 0)
  setTimeout(rewriteWhatsAppLinks, 100)
  if (!clickBound) {
    clickBound = true
    document.addEventListener('click', onWhatsAppClick, true)
  }
}
